export default __webpack_public_path__ + "static/media/cont15.44652cbe.png";